import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from "antd";
import { LegacyIcon } from "../common/legacyIcon.js";
function SearchBox({ autoFocus, disabled, searchTerm, searchInputBusy, resultTreeBusy, onChange, onBlur, onKeyDown, onClose }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "aiot-search",
        children: /*#__PURE__*/ _jsx(Input, {
            autoFocus: autoFocus,
            disabled: disabled,
            size: "small",
            variant: "outlined",
            value: searchTerm,
            onChange: onChange,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
            suffix: searchInputBusy || resultTreeBusy ? /*#__PURE__*/ _jsx(LegacyIcon, {
                type: "loading",
                spin: true
            }) : searchTerm.length ? /*#__PURE__*/ _jsx(LegacyIcon, {
                type: "close",
                style: {
                    cursor: "pointer"
                },
                onClick: onClose
            }) : /*#__PURE__*/ _jsx(LegacyIcon, {
                type: "search"
            })
        })
    });
}
export { SearchBox };
